import { Injectable } from '@angular/core';
import { AdminManagementService } from './admin-management.service';
import { map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { CanUserAccessAdminGQL } from '../../generated/types';
import { AdminUiRights } from '@onep/front-portal-lib';

@Injectable()
export class AdminManagementImplService implements AdminManagementService {
  constructor(
    private canUserAccessAdminGQL: CanUserAccessAdminGQL,
    private securityService: OidcSecurityService
  ) {}

  /**
   * Compute the current user to know if he is admin.
   */
  getUserAdminRights(): Observable<AdminUiRights> {
    return this.canUserAccessAdminGQL
      .fetch({}, { fetchPolicy: 'network-only', errorPolicy: 'all' })
      .pipe(
        map((result) => result.data.authenticatedUser.uiRights),
        tap((uiRights) => {
          if (!uiRights.canAccessAdmin) {
            this.securityService.logoffAndRevokeTokens().subscribe(() => {
              location.href =
                this.securityService.configuration.wellknown
                  .authorizationEndpoint +
                '/admin?error=USER_NOT_ALLOWED_TO_ACCESS_ADMIN&type=ADMIN';
            });
          }
        })
      );
  }
}
